import { cn } from "@/lib/utils";

/**
 * A compact covered-wagon icon with a green "B" (Bitcoin Cash) on the canvas.
 * Used in the header/branding in place of the shopping-cart emoji.
 */
export function WagonIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 48"
      className={cn("h-9 w-12", className)}
      role="img"
      aria-label="Covered wagon with a Bitcoin Cash B"
    >
      {/* wagon bed */}
      <rect x="8" y="26" width="48" height="11" rx="2" className="fill-amber-950 dark:fill-amber-900" />
      {/* canvas cover (bonnet) */}
      <path
        d="M10 27 Q 12 5 32 5 Q 52 5 54 27 Z"
        className="fill-stone-100 dark:fill-stone-300"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* canvas ribs */}
      <g className="stroke-stone-400/70" strokeWidth="1.2" fill="none">
        <path d="M22 9 Q 20 20 19 27" />
        <path d="M43 9 Q 45 20 46 27" />
      </g>
      {/* green B */}
      <text
        x="32"
        y="23"
        textAnchor="middle"
        fontSize="18"
        fontWeight="bold"
        fontFamily="Georgia, 'Times New Roman', serif"
        className="fill-green-600 dark:fill-green-400"
      >
        B
      </text>
      {/* wheels */}
      <g className="fill-none stroke-stone-800 dark:stroke-stone-200" strokeWidth="2.5">
        <circle cx="20" cy="39" r="6" />
        <circle cx="46" cy="39" r="6" />
      </g>
      <g className="stroke-stone-800 dark:stroke-stone-200" strokeWidth="1.2">
        <line x1="20" y1="34" x2="20" y2="44" />
        <line x1="15" y1="39" x2="25" y2="39" />
        <line x1="46" y1="34" x2="46" y2="44" />
        <line x1="41" y1="39" x2="51" y2="39" />
      </g>
    </svg>
  );
}
